export async function stationCreateUseCase(stationData, stationRepository) {

    const result = await stationRepository.create(stationData);

    const entity = new stationRepository.model(result.data.success.arguments);
    
    if (!entity.isValid()) {
      throw new Error("Estación inválido");
    }

    return result;
}